<template>
	 <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark>
                <v-toolbar-title>Sign Up - Display Case Manager</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field prepend-icon="mail" name="email" label="E-mail" :error-messages="errors.collect('user.email')" 
                   type="text" v-model="user.email" v-validate="'required|email'" data-vv-name='user.email' required></v-text-field>
                 <!--  <v-text-field prepend-icon="person" name="username"
                   label="Username" type="text" v-model="user.username"
                   v-validate="'required|alpha_num'" data-vv-name='user.username' :error-messages="errors.collect('user.username')" required>
                   </v-text-field> -->
                  <v-text-field id="password" prepend-icon="lock" name="password"
                   v-validate="'required:true, regex:/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/'"
                   data-vv-name='user.password' :error-messages="errors.collect('user.password')" required
                   label="Password"  v-model="user.password"
                    :type="show2 ? 'text' : 'password'"
                    :append-icon="show2 ? 'visibility_off': 'visibility'"
                    @click:append="show2 = !show2"
                   ></v-text-field>
                  <v-text-field  prepend-icon="person" id="fname" name="fname" label="First Name" type="text" v-model="user.firstName"
                  v-validate="'required|alpha'" data-vv-name='user.firstName' :error-messages="errors.collect('user.firstname')" required
                   ></v-text-field>
                  <v-text-field  prepend-icon="person" id="lname" name="lname" label="Last Name" type="text" v-model="user.lastName"
                  v-validate="'required|alpha'" data-vv-name='user.lastName' :error-messages="errors.collect('user.lastname')" required
                  ></v-text-field>
                  <captcha
                    ref="recaptcha"
                    :sitekey="siteKey"
                    @verify = "onVerify"
                    @expired= "onExpired"
                  ></captcha>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn dark @click.native= "signup">Sign Up</v-btn>
                <v-btn dark @click.native ="cancel">Cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
        <v-dialog v-model="openDialog" max-width="500px" >
        <v-card>
          <v-card-title class="error white--text">
            <v-icon class="white--text pr-3">warning</v-icon><span>Sign up - Error</span>
            <v-icon class="white--text pl-2">fa-frown-o</v-icon>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
          <p>{{errorMsg}}</p>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" flat @click.stop="openDialog=false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="grant" max-width="500px" >
        <v-card>
          <v-card-title class="success white--text">
            <v-icon class="white--text pr-3">check</v-icon><span>User Created</span>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
          <p>{{msg}} <v-icon class="white--text pl-2">tag_faces</v-icon></p>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" flat @click.stop="toLogin(grant=false)">Ok</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      </v-container>
</template>

<script>
  import VueRecaptcha from 'vue-recaptcha'
  export default {
    components: {
      captcha: VueRecaptcha
    },
    $validates: true,
    name: 'Logout',
    data: () => ({
      user: {
        email: '',
        firstName: '',
        lastName: '',
        password: '',
        captchaToken: ''
      },
      openCaptcha: false,
      siteKey: '6LckcoUUAAAAAADvzeIYlFgM7XyhZqaTPUx-upzK',
      grant: false,
      errorMsg: '',
      msg: '',
      openDialog: false,
      show2: false,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Min 8 characters'
      }
    }),
    methods: {
      cancel () {
        this.$router.push('/')
      },
      signup () {
        if (this.user.captchaToken !== '') {
          this.$http.post('/auth/signup', this.user)
          .then(request => this.success(request))
          .catch(() => this.failedSignUp())
        }
      },
      success (req) {
        if (req.status === 201) {
          this.msg = 'User successfully created. Login with your new credentials.'
          this.grant = true
        } else {
          this.errorMsg = 'Please check your information fields'
          this.openDialog = true
        }
      },
      failedSignUp () {
        this.errorMsg = 'Sorry, something went wrong. Please try again.'
        this.openDialog = true
      },
      toLogin (val) {
        this.grant = val
        this.$router.push('/')
      },
      onSubmit: function () {
        this.$refs.recaptcha.execute()
      },
      onVerify: function (response) {
        this.user.captchaToken = response
      },
      onExpired: function () {
        console.log('Captcha Expired')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Login/Signup.vue